import React from "react";


export const Footer = () => {

    return (
        <footer className="main-footer row footerfix d-none d-sm-none d-md-none" >
            <div className="col-md-8 d-flex align-items-center ">
                <strong>Copyright &copy; 2016-2021 <a href="https://netco.com.vn">NETCO POST</a>.</strong> All rights reserved. Develop by NETCO IT Team
            </div>
            <div className="col-md-4 d-flex align-items-center justify-content-center">
                <p className="m-0"> <b>Version</b> 1.0.0</p>
            </div>
        </footer>
    )
}